import apolloClient from 'apollo-client'
import {
  GET_BULK_FULFILLMENTS,
  CREATE_BULK_FULFILLMENT,
  UPDATE_BULK_FULFILLMENT_ORDERS,
  GET_BULK_FULFILLMENT_ORDERS,
  PUBLISH_FULFILLMENT_BATCH,
  PUBLISH_FULFILLMENT_BATCH_ORDERS,
  UPDATE_BULK_FULFILLMENT_ORDER,
  CREATE_IN_HOUSE_FULFILLMENT_BATCH,
  GET_READY_TO_FULFILL_ORDERS_BY_BATCH_ID,
  UPDATE_IN_HOUSE_FULFILLMENT,
} from './graphql'

import isArray from 'lodash/isArray'

class BulkFulfillmentService {
  async list(params: any) {
    const {data} = await apolloClient.query({
      query: GET_BULK_FULFILLMENTS,
      variables: params,
    })

    const {nodes, totalCount} = data.fulfillmentBatches
    return {list: nodes, totalCount}
  }

  async create(fulfillment: any) {
    const {data} = await apolloClient.mutate({
      mutation: CREATE_BULK_FULFILLMENT,
      variables: fulfillment,
    })

    return data.createFulfillmentBatch.uuid
  }

  async updateOrders(orders: any) {
    await apolloClient.mutate({
      mutation: UPDATE_BULK_FULFILLMENT_ORDERS,
      variables: {orders},
    })
  }

  async updateOrder(id: string, data: any) {
    return await apolloClient.mutate({
      mutation: UPDATE_BULK_FULFILLMENT_ORDER,
      variables: {id, patch: data},
    })
  }

  async publish(id: string) {
    const {errors} = await apolloClient.mutate({
      mutation: PUBLISH_FULFILLMENT_BATCH,
      variables: {id},
    })

    if (errors) {
      throw errors
    }
  }

  async publishBatchOrders(ids: any[], fulfillmentBatchId: string) {
    const {errors} = await apolloClient.mutate({
      mutation: PUBLISH_FULFILLMENT_BATCH_ORDERS,
      variables: {ids, fulfillmentBatchId},
    })

    if (errors) {
      throw errors
    }
  }

  async listOrder(id: string) {
    const {data} = await apolloClient.query({
      query: GET_BULK_FULFILLMENT_ORDERS,
      variables: {
        id,
      },
    })

    const {nodes, totalCount} = data.getOrdersToFulfill
    return {
      orders: nodes.map((order: any) => {
        order.selected = false
        order.errors = formatJSON2(order.message)
        order.message = formatJSON(order.message)
        return order
      }),
      totalCount,
    }
  }

  async getReadyToFulfillOrdersByBatchId(batchId: string) {
    const {data, errors} = await apolloClient.mutate({
      mutation: GET_READY_TO_FULFILL_ORDERS_BY_BATCH_ID,
      variables: {batchId},
    })
    if (errors) {
      throw errors
    }
    const {nodes} = data.getReadyToFulfillOrdersByBatchId
    return nodes.map((order: any) => {
      return {...order, selected: false, doc: {packageSlip: order.packageSlip}}
    })
  }

  async updateInHouseFulfillment({fulfillmentId, tracking, orderId}: any) {
    return await apolloClient.mutate({
      mutation: UPDATE_IN_HOUSE_FULFILLMENT,
      variables: {fulfillmentId, tracking, orderId},
    })
  }

  async createInHouseBatch(orderIds: any[]) {
    const {data, errors} = await apolloClient.mutate({
      mutation: CREATE_IN_HOUSE_FULFILLMENT_BATCH,
      variables: {orderIds},
    })
    if (errors) {
      throw errors
    }
    return data.createInHouseFulfillmentBatch.uuid
  }
}

const fulfillmentService = new BulkFulfillmentService()

export default fulfillmentService

function formatJSON(str: string) {
  try {
    const value = JSON.parse(str).message
    if (value) {
      return JSON.parse(value).errors[0].message
    }
  } catch (e) {
    return str
  }
}

function formatJSON2(str: string) {
  try {
    const value = JSON.parse(str)
    if (isArray(value)) {
      return value
    }
    if (value && value.message) {
      const message = JSON.parse(value.message)
      if (message.errors) {
        return message.errors
      }
    }
  } catch (e) {}
}
